import {Document} from 'substance'

/**
 * IdfDocument (document) implementation
 */
class IdfDocument extends Document {

    constructor(...args) {
        super(...args)

        // this.pluginManager = null
        // this.xmlDocument = null
    }
}

export {IdfDocument}
